import { Type } from 'class-transformer';
import {
  ArrayNotEmpty,
  IsArray,
  IsEmail,
  IsNumber,
  IsString,
  ValidateNested,
} from 'class-validator';

export class StaffInvitation {
  @IsNumber()
  employeeId: number;
  @IsString()
  employeeNumber: string;
  @IsNumber()
  mealCardTypeId: number;
  @IsNumber()
  roleComponentId: number;
  @IsNumber()
  merchantGroupId: number;
  @IsNumber()
  merchantId: number;
  @IsEmail()
  email: string;
  @IsArray()
  @IsString({ each: true })
  chatChannels: string[];
}

export class BulkCreateUserFromInvitationsRequestDto {
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => StaffInvitation)
  invitations: StaffInvitation[];
}
